import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Courses from './pages/Courses';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Post from "./pages/Post";
import Coursessingle from "./pages/Coursessingle";
import Thankyou from "./pages/Thankyou";
import Aboutus from "./pages/Aboutus";
import SuccessPage from "./pages/SuccessPage";
import Oneonone from "./pages/Oneonone";



const App = () => {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/personality-development-courses" element={<Courses />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/:slug" element={<Post />} />
        <Route path="/courses/:slug" element={<Coursessingle />} />
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/one-on-one-transformation" element={<Oneonone />} />
      </Routes>
      <Footer />
    </div>
  );
};



export default App;